import { API_RESOURCE } from '@/constants/api.constant'
import { useCrud } from '@/hooks/useCrud'
import { createOptions } from '@/utils/arrayHelper'
import { camelToWords } from '@/utils/stringHelper'
import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import FrameAgreementService from './frameAgreement.service'

const useFrameAgreement = () => {
  const service = new FrameAgreementService()
  const baseCrud = useCrud(API_RESOURCE.FRAME_AGREEMENT, service)

  const queryClient = useQueryClient()

  const useUploadFrameAgreements = () => {
    return useMutation({
      mutationFn: (file) => service.uploadFrameAgreement(file),
      onSuccess: (res) => {
        toast.info(`Successfully Upload  ${camelToWords(API_RESOURCE.FRAME_AGREEMENT)}`)

        queryClient.invalidateQueries(baseCrud.queryKey.lists())
      },
    })
  }

  const useFrameAgreementOptions = (payload = {}) => {
    const { status = 'active', valueKey = '_id' } = payload
    return useQuery({
      queryKey: [...baseCrud.queryKey.list({ page: 1, pageSize: 0, filters: { status: status } })],
      queryFn: () => service.fetchAll({ page: 1, pageSize: 0, filters: { status: status } }),
      placeholderData: keepPreviousData,
      select: (data) => {
        return createOptions(data?.data?.results, 'name', valueKey)
      },
    })
  }

  return {
    //Base CRUD
    useFetchAllFrameAgreements: baseCrud.useFetchAll,
    useFetchFrameAgreement: baseCrud.useFetchOne,
    useCreateFrameAgreement: baseCrud.useCreate,
    useUpdateFrameAgreement: baseCrud.useUpdate,
    useRemoveFrameAgreement: baseCrud.useRemove,

    //Extra
    useUploadFrameAgreements,
    useFrameAgreementOptions,
  }
}

export default useFrameAgreement
